const palette = {
  primary: {
    main: "#006400",
  },

  secondary: {
    main: "#2E7D32",
  },

  background: {
    default: "#FAF8F5",
    paper: "#FFFFFF",
  },

  success: {
    main: "#2E7D32",
  },

  warning: {
    main: "#ED6C02",
  },

  error: {
    main: "#D32F2F",
  },

  info: {
    main: "#0288D1",
  },

  text: {
    primary: "#1F2937",
    secondary: "#6B7280",
  },
};

export default palette;
